import React from 'react';

const domain = location.host.replace('www.', '').split('.')[0];
const name = domain.charAt(0).toUpperCase() + domain.slice(1);
const host = location.host;

const newColumns = [
  {
    type: 'icon',
    icon: 'fa fa-money',
    label: 'Ecommerce',
    text: `Use state of the art ecommerce chat and ticketing tools
           such as liveperson, intercom, tawk to, and many other
           tools that will help you become a better professional.`
  },
  {
    type: 'icon',
    icon: 'fa fa-globe',
    label: 'Global',
    text: `Our jobs are in a variety of languages starting with english
           but continuing with spanish, french, german, and other 
           international languages.`
  },
  {
    type: 'icon',
    icon: 'fa fa-map-marker',
    label: 'Support',
    text: `Learn customer support for free on our platform,
           as well as ticketing etiquette, and best practices
           when it comes to speaking with customers online
           or through email or phone.`
  },
  {
    type: 'icon',
    icon: 'fa fa-clock-o',
    label: 'Time',
    text: `Your career is important, learn things fast while actually working
           and taking courses online from the best teaches in the market,
           learn fast and apply that in real life!`
  }
];

const newContacts = {
  title: name + ' TM',
  mobile: '+1.507.774.0755',
  text: (
    <div class='mt-3'>
      Alaco Marketing LLC, 3022 Senna CT, Orlando, FL 32826, USA {host} +1.213.205.0017
      <br />
      EMAIL : support@billsinvo.com
    </div>
  )
};

const domainConfigs = {
  cashplane: {
    title: 'CashPlane',
    logo: {
      // image: "http://www.cashplane.net/assets/img/cashplane3.png"
      text: 'CashPlane'
    },
    plane: '//www.cashplane.net/assets/login/img/plane.png',
    // backgroundImage: require("assets/images/login-background.jpeg"),
    // signupImage: require("assets/images/visual.png"),
    signupImage: require('assets/images/leadpages.png'),
    contacts: {
      title: 'Philippine Affiliate Manager',
      name: 'SIRWIL',
      skype: 'SIRWIL75',
      mobile: '09175308552',
      text: (
        <div class='mt-3'>
          CashPlane CEO
          <br />
          Dorin
          <img
            src='https://upload.wikimedia.org/wikipedia/commons/3/3a/At_sign_in_Bitstream_Vera_Sans.svg'
            height='12'
          />
          cashplane.com
          <br />
          Teams : daredariuz
        </div>
      )
    }
  },
  onlycash: {
    signupImage: require('assets/images/onlycash.png'),
    signupImageTitle: 'Beware : We do not pay anyone to Rate Videos'
  },
  cashfans: {
    title: 'CashFans',
    logo: {
      text: 'CashFans'
    },
    signupImage: require('assets/images/cashfans.png'),
    favicon: require('assets/images/favicon_dollar.ico')
  },
  naughtyoffers: {
    title: 'NaughtyOffers',
    logo: {
      text: 'NaughtyOffers'
    },
    form: {
      small: true,
      background: '#f0fff0'
    },
    signupImage: require('assets/images/how-to-choose-best-affiliate-program-1.jpg'),
    favicon: require('assets/images/favicon_dollar.ico')
  },
  // laserprofit: {
  //   title: 'LaserProfit',
  //   signupButton: 'Apply now',
  //   signupImage: require('assets/images/iworkbay.jpg'),
  //   signupImageText: `
  //     We offer up to 45 USD per customer sent to our offers!
  //     Weekly payouts no hold! Amazing pay per lead conversions!`,
  //   footerText: 'Herodot SRL',
  //   linkedIn: 'https://www.linkedin.com/in/dorinlucian',
  //   favicon: require('assets/images/favicon_dollar.ico'),
  //   plane: require('assets/images/chatoffices_logo.png'),
  //   logo: {
  //     text: 'LaserProfit'
  //   },
  //   newHome: true,
  //   contacts: {
  //     title: 'Laserprofit TM',
  //     mobile: '+1.507.774.0755',
  //     text: (
  //       <div class='mt-3'>
  //         Herodot SRL, Aleea Baiut nr.3 Bl D14, sc D ap 34, 061953, Bucharest, Romania {host}{' '}
  //         +40217777719
  //         <br />
  //         EMAIL : office@laserprofit.com
  //       </div>
  //     )
  //   }
  // },
  laserprofit: {
    title: 'LaserProfit',
    // companyName: 'AAAA Careu De ASI SRL',
    signupButton: 'Apply now',
    signupImage: require('assets/images/Laser7.png'),
    // signupImageText: `
    //   We AAAA Careu de ASI SRL at LaserProfit created an affiliate program software panel, that can be rented as a service, or used by our affiliates to promote our internal offers for a commission ranging from $4 per lead to $60 per sale transmited to our sponsors. Weekly payouts for your affiliate commission!
    // `,
    // footerText: 'AAAA Careu de ASI SRL',
    linkedIn: 'https://www.linkedin.com/in/dorinlucian',
    favicon: require('assets/images/favicon_dollar.ico'),
    // plane: require('assets/images/chatoffices_logo.png'),
    // plane: require('assets/images/LaserLogo2.png'),
    plane: 'none',
    logo: {
      text: 'LaserProfit'
    },
    newHome: true,
    hideContactUs: true,
    contacts: {
      // title: 'AAAA Careu de ASI SRL',
      // mobile: '+1.507.774.0755',
      text: (
        <div class='mt-3'>
          {/*AAAA Careu de ASI SRL, Aleea Baiut nr.3 Bl D14, sc D ap 34, 061953, Bucharest, Romania{' '}*/}
          {host}
          <br />
          EMAIL : office@laserprofit.com <br />
          Phone : +1507.774.0755
        </div>
      )
    }
  },
  carbonprofit: {
    title: 'CarbonProfit',
    logo: {
      text: 'CarbonProfit'
    }
  },
  shakirachat: {
    title: 'ShakiraChat',
    logo: {
      text: 'ShakiraChat'
    },
    signupImage: require('assets/images/shakirachat.png'),
    contacts: {
      title: 'Affiliate Manager',
      name: 'Al Dwayne',
      skype: 'live:Shakiracambrille',
      mobile: '+447418335237',
      text: `
For any affiliate questions you have feel free to contact us 
using the information above.
      `
    }
  },
  cashofficers: {
    signupImage: require('assets/images/affiliate-marketing.png')
  },
  bestchatters: {
    title: 'BestChatters',
    logo: {
      text: 'BestChatters'
    },
    signupImage: require('assets/images/snapchat.png'),
    contacts: {
      title: 'Philippine Affiliate Manager',
      name: 'WEBSTER',
      skype: 'WEBSTER',
      mobile: '09289771066',
      text: `
CHAT SUPPORT

Name: MIEL SY
live:g_e_b_2
      `
    }
  },
  chatleaders: {
    title: 'ChatLeaders',
    logo: {
      text: 'ChatLeaders'
    },
    contacts: {
      title: 'Philippine Affiliate Manager',
      name: 'Melanie Cabalida',
      skype: 'melanie.cabalida2',
      mobile: '09171936727',
      text: `
CHAT SUPPORT

Name: MIEL SY
live:g_e_b_2
      `
    }
  },
  cashpenthouse: {
    title: 'CashPenthouse',
    logo: {
      text: 'CashPenthouse'
    },
    contacts: {
      title: 'Philippine Affiliate Manager',
      name: 'Melanie Cabalida',
      skype: 'melanie.cabalida2',
      mobile: '09171936727',
      text: `
CHAT SUPPORT

Name: MIEL SY
live:g_e_b_2
      `
    }
  },
  chatoffices: {
    title: 'ChatOffices',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/iworkbay.jpg'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'ChatOffices'
    },
    columns: newColumns,
    newHome: true,
    contacts: newContacts
  },
  vipchatting: {
    title: 'VipChatting',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/chatoffices.png'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'VipChatting'
    },
    columns: newColumns,
    newHome: true
  },
  chatjobs: {
    title: 'ChatJobs',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/iworkbay.jpg'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'ChatJobs'
    },
    columns: newColumns,
    newHome: true,
    contacts: newContacts
  },
  iworkbay: {
    title: 'iWorkBay',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/iworkbay.jpg'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'iWorkBay'
    },
    columns: newColumns,
    newHome: true,
    contacts: newContacts
  },
  vipchatters: {
    title: 'VIPChatters',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/iworkbay.jpg'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'VIPChatters'
    },
    columns: newColumns,
    newHome: true,
    contacts: newContacts
  },
  hookupbucks: {
    title: 'HookupBucks',
    signupButton: 'Apply for job',
    signupImage: require('assets/images/iworkbay.jpg'),
    favicon: require('assets/images/favicon_dollar.ico'),
    plane: require('assets/images/chatoffices_logo.png'),
    logo: {
      text: 'HookupBucks'
    },
    columns: newColumns,
    newHome: true,
    contacts: newContacts
  },

  default: {
    title: name,
    companyName: 'Herodot SRL',
    newHome: false,
    favicon: require('assets/images/favicon.ico'),
    form: {
      small: false,
      background: '#ffffff'
    },
    logo: {
      text: domain.toUpperCase()
    },
    plane: 'https://cdn0.iconfinder.com/data/icons/free-business-desktop-icons/256/Money.png',
    // signupImage: require("assets/images/cash_big.jpg"),
    signupImage: require('assets/images/register1.png'),
    signupImageText: false,
    footerText: false,
    linkedIn: '#',
    signupButton: 'Sign up',
    backgroundImage: '',
    columns: [
      {
        type: 'img',
        icon: require('assets/images/cash.png'),
        label: 'Payouts',
        text: `Probably the greatest payout model in industry, 
             for each 1000 free members you will earn the most with us.`
      },
      {
        type: 'img',
        icon: require('assets/images/terra.png'),
        label: 'Global',
        text: `${name} is a global company, 
             with offers all over the world, 
             and accepting partners from any country.`
      },
      {
        type: 'img',
        icon: require('assets/images/location.png'),
        label: 'Landings',
        text: `With our state of the art geo landing page design, 
             you are assured to have the very best conversions.`
      },
      {
        type: 'img',
        icon: require('assets/images/clock.png'),
        label: 'Fast',
        text: `Your payments will be sent fast, 
             and will reach your accounts like clock work
             tu assure good collaboration.`
      }
    ],
    contacts: ``,
    hideContacts: false
  }
};

const promoConfigs = {
  snapchatpromo: {
    signupImage: require('assets/images/snapchat.png')
  }
};

let defaultConfig = domainConfigs.default;
let domainConfig = domainConfigs[domain] || {};

const resultConfig = {
  title: domainConfig.title || defaultConfig.title,
  companyName: domainConfig.companyName || defaultConfig.companyName,
  favicon: domainConfig.favicon || defaultConfig.favicon,
  form: domainConfig.form || defaultConfig.form,
  logo: domainConfig.logo || defaultConfig.logo,
  plane: domainConfig.plane || defaultConfig.plane,
  signupImage: domainConfig.signupImage || defaultConfig.signupImage,
  signupImageText: domainConfig.signupImageText || defaultConfig.signupImageText,
  signupImageTitle: domainConfig.signupImageTitle || defaultConfig.signupImageTitle,
  footerText: domainConfig.footerText || defaultConfig.footerText,
  linkedIn: domainConfig.linkedIn || defaultConfig.linkedIn,
  signupButton: domainConfig.signupButton || defaultConfig.signupButton,
  backgroundImage: domainConfig.backgroundImage || defaultConfig.backgroundImage,
  columns: domainConfig.columns || defaultConfig.columns,
  contacts: domainConfig.contacts || defaultConfig.contacts,
  newHome: domainConfig.newHome || defaultConfig.newHome,
  hideContactUs: domainConfig.hideContactUs || defaultConfig.hideContactUs
};

document.title = resultConfig.title;
document.getElementsByTagName('META')[1].content = resultConfig.title;
document.querySelector("link[rel='shortcut icon']").href = resultConfig.favicon;

function getPromo(promo) {
  let promoConfig = promoConfigs[promo];
  return {
    title: promoConfig.title || resultConfig.title,
    favicon: promoConfig.favicon || resultConfig.favicon,
    form: promoConfig.form || resultConfig.form,
    logo: promoConfig.logo || resultConfig.logo,
    plane: promoConfig.plane || resultConfig.plane,
    signupImage: promoConfig.signupImage || resultConfig.signupImage,
    signupImageText: promoConfig.signupImageText || resultConfig.signupImageText,
    footerText: promoConfig.footerText || resultConfig.footerText,
    linkedIn: promoConfig.linkedIn || resultConfig.linkedIn,
    signupButton: promoConfig.signupButton || resultConfig.signupButton,
    backgroundImage: promoConfig.backgroundImage || resultConfig.backgroundImage,
    columns: promoConfig.columns || resultConfig.columns,
    contacts: promoConfig.contacts || resultConfig.contacts,
    newHome: promoConfig.newHome || resultConfig.newHome,
    hideContactUs: promoConfig.hideContactUs || resultConfig.hideContactUs
  };
}

export { resultConfig as domainConfig, domain, getPromo };
